// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__2Sxte","lastComm":"Sidebar_lastComm__3P0Vk"};